import { Button } from "ui/components/button";
import { Label } from "ui/components/label";
import useTableFilters from "hooks/src/useTableFilters";
import UserCombobox from "components/directus/combobox/user";
import SelectStatus from "components/select/status";
import IndustryInput from "components/industry/input";
import NdaInput from "components/nda/input";
import ProjectCombobox from "components/directus/combobox/project";
import { useSelector } from "react-redux";
import { selectUser } from "store/src/slices/auth-slice";
import SelectName from "components/select/name";

export default function CaseStudiesFilters({
  filters,
  setFilters,
  setIsOpen,
  isOpen,
  defaultFilters,
  clearFilters,
}) {
  const { id } = useSelector(selectUser);
  const {
    localFilters,
    applyFilters,
    clearLocalFilters,
    handleSetLocalFilters,
  } = useTableFilters({
    filters,
    setFilters,
    setIsOpen,
    clearFilters,
    initialFilters: {
      user_created: undefined,
      project: undefined,
      status: undefined,
      industry: undefined,
      nda_level: undefined,
      tech_stack: undefined,
      tools: undefined,
      ...defaultFilters,
    },
  });

  return (
    <div className="w-full p-4 space-y-4">
      <div>
        <Label className="mb-2 text-sm">Author</Label>
        <UserCombobox
          value={localFilters?.user_created?._eq}
          onChange={(selectedItem) => {
            handleSetLocalFilters({ user_created: { _eq: selectedItem } });
          }}
          dependenton={isOpen}
        />
      </div>
      <div>
        <ProjectCombobox
          value={localFilters.project?._eq}
          className="w-full"
          placeholder="Select"
          filter={{
            _or: [
              {
                coordinator: {
                  _eq: id,
                },
              },
              {
                jobs: {
                  coordinator: {
                    _eq: id,
                  },
                },
              },
            ],
          }}
          searchPlaceholder="Search Project..."
          onChange={(selectedItem) =>
            handleSetLocalFilters({
              project: selectedItem ? { _eq: selectedItem } : undefined,
            })
          }
        />
      </div>
      <div>
        <Label className="mb-2 text-sm">Status</Label>
        <SelectStatus
          collection="case_studies"
          value={localFilters?.status?._eq}
          onChange={(selectedItem) => {
            handleSetLocalFilters({
              status: selectedItem ? { _eq: selectedItem } : undefined,
            });
          }}
        />
      </div>
      <div>
        <Label className="mb-2 text-sm">Tech Stack</Label>
        <SelectName
          collection="tech_stack"
          fetchItems
          value={localFilters?.tech_stack?.tech_stack?._eq}
          onChange={(selectedItem) => {
            handleSetLocalFilters({
              tech_stack: { tech_stack: selectedItem ? { _eq: selectedItem } : undefined },
            });
          }}
        />
      </div>
      <div>
        <Label className="mb-2 text-sm">Tools</Label>
        <SelectName
          collection="tools"
          fetchItems
          value={localFilters?.tools?.tool?._eq}
          onChange={(selectedItem) => {
            handleSetLocalFilters({
              tools: { tool: selectedItem ? { _eq: selectedItem } : undefined },
            });
          }}
        />
      </div>
      <div>
        <Label className="mb-2 text-sm">Industry</Label>
        <IndustryInput
          value={localFilters?.industry?._eq}
          onChange={(selectedItem) => {
            handleSetLocalFilters({
              industry: selectedItem ? { _eq: selectedItem } : undefined,
            });
          }}
        />
      </div>
      <div>
        <Label className="mb-2 text-sm">NDA Level</Label>
        <NdaInput
          value={localFilters?.nda_level?._eq}
          onChange={(selectedItem) => {
            handleSetLocalFilters({
              nda_level: selectedItem ? { _eq: selectedItem } : undefined,
            });
          }}
        />
      </div>

      {/* Action Buttons */}

      <div className="flex place-self-end gap-4">
        <Button variant="outline" onClick={clearLocalFilters}>
          Clear
        </Button>

        <Button onClick={() => applyFilters()}>Apply</Button>
      </div>
    </div>
  );
}
